<template>
  <div
    class="w-full flex flex-col items-center justify-center m-auto gap-5 text-gray-200 text-center rounded-xl mt-2"
    :class="{
      'border rounded-2xl py-5': compact && !plain,
      'py-8 px-6': !compact,
      'h-96': large,
      'border border-opacity-20 bg-opacity-20': !plain,
      'py-5': plain
    }"
  >
    <template v-if="!compact">
      <template v-if="img">
        <img class="w-64" :src="`/` + img + `.svg`" alt="" />
      </template>
      <img v-else class="w-64" src="/img/blank.png" alt="" />
    </template>
    <h1
      v-if="title"
      class="text-gray-400 text-center"
      :class="{
        'text-md sm:text-lg px-10': !compact,
        'text-sm px-2 text-gray-400': compact,
      }"
    >
      {{ title }}
    </h1>
    {{ message }}
    <slot name="button" />
  </div>
</template>

<script>
export default {
  props: {
    img: String,
    title: String,
    message: String,
    compact: Boolean,
    large: Boolean,
    plain: Boolean
  },
  components: {},
};
</script>
